import React, { Component } from 'react'
import Modal from 'react-modal'
import { Glyphicon, Grid, Row, Col, ListGroup, ListGroupItem } from 'react-bootstrap'

import ChooseLockUser from './ChooseLockUser'
import { getSubModalStyles } from '../utils'
import MultiCompanySelect from './MultiCompanySelect'

class ChooseLockUserModal extends Component {
    constructor(props) {
        super(props)
    }

    state = {
        search: '',
        selectedUsers: [],
        selectedCompany: null
    }

    onChange = (key, val) => {
        this.setState({ [key]: val })
    }

    finished = () => {
        this.props.sendResults(this.state)
        this.props.closeModal()
    }

    render() {
        const { allowChooseCompanies } = this.props

        return (
            <Modal
                ariaHideApp={false}
                isOpen={true}
                onRequestClose={() => this.props.closeModal()}
                style={getSubModalStyles(.9)}>

                <div className="qCloseButton" onClick={() => this.props.closeModal()}>Stäng</div>

                <br />
                <br />

                <Grid fluid>
                    {allowChooseCompanies ?
                        <>
                            <Row>
                                <Col xs={2} md={3}>
                                    &nbsp;
                                </Col>
                                <Col xs={12} md={6}>
                                    <h4 style={{ textAlign: 'center' }}>För vilket företag vill du skapa en logistikare?</h4>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={2} md={3}>
                                    &nbsp;
                                </Col>
                                <Col xs={12} md={6}>
                                    <MultiCompanySelect lock={this.props.lock} onChange={(selectedCompanies) => this.setState({ selectedCompanies: selectedCompanies.map(c => c.value) })} />
                                </Col>
                            </Row>
                            <br /><br />
                        </>
                        :
                        null
                    }

                    <Row>
                        <Col xs={2} md={3}>
                         &nbsp;
                        </Col>
                        <Col xs={12} md={6}>
                            <h4 style={{ textAlign: 'center' }}>Vem/vilka är logistikare?</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={2} md={3}>
                            &nbsp;
                        </Col>
                        <Col style={{padding: 0}} xs={12} md={6}>
                          <ChooseLockUser lock={this.props.lock} finished={this.finished} change={this.onChange} />
                        </Col>
                    </Row>
                </Grid>
            </Modal>
        )
    }
}

export default ChooseLockUserModal